export default {
  props: {
    /**
      * Company name
      */
    companyName: {type: String, default: 'Tribus Digital'}
  }
};
